"use server";

import { cookies } from "next/headers";
import { revalidatePath } from "next/cache";
import { COOKIE_THEME, isThemeMode, type ThemeMode } from "./types";

/**
 * Server Action — zapisuje wybór motywu do cookie i triggeruje revalidate
 * żeby Server Component (root layout) re-renderował z nowym `data-theme`.
 *
 * Wzorzec analogiczny do `lib/admin/actions.ts::setActiveTabAction`.
 */
export async function setThemeAction(
  theme: ThemeMode,
): Promise<{ ok: boolean; error?: string }> {
  if (!isThemeMode(theme)) {
    return { ok: false, error: `Invalid theme mode: ${theme}` };
  }

  const cookieStore = await cookies();
  cookieStore.set(COOKIE_THEME, theme, {
    path: "/",
    maxAge: 60 * 60 * 24 * 365, //1 year
    sameSite: "lax",
    httpOnly: false, //Client component czyta dla optimistic state
  });

  revalidatePath("/", "layout");
  return { ok: true };
}
